import React from "react";

import "./ACSettingSectionTitle.less";

interface ACSettingSectionTitleProps {
  title: React.ReactNode | string;
  description?: React.ReactNode | React.ReactNode[];
}
export default function ACSettingSectionTitle({
  title,
  description,
}: ACSettingSectionTitleProps) {
  return (
    <div className="ac-setting-section-title">
      <div className="ac-setting-section-title-content">
        <div className="ac-setting-section-title-content-title">{title}</div>
        {description && (
          <div className="ac-setting-section-title-content-description">
            {description}
          </div>
        )}
      </div>
    </div>
  );
}
